import Loader from "../../components/shared/Loader";
import {interventionStatus, userRoleList} from "../../../utils/constants";
import {useMe} from "../../../hooks/useGetUser";
import imagePub from "../../../images/ImagePub.jpg";
import arrow from "../../../images/arrowIntervention.png";
import BgPattern from "../../../images/BG-Pattern.png";
import Weather from "../../components/shared/Weather";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoProfile from "../../../images/profileImage.png";
import Crown from "../../../images/crownIcon.svg";

import InterventionItem from "../../components/offer/interventionItem";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {simpleDate} from "../../../utils/date";
import {Link, Outlet} from "react-router-dom";
import ProfileCompletion from "../../components/Profile/ProfileCompletion";
import {use, useEffect, useState} from "react";
import PubList from "../../components/shared/PubList";

const TechContainer = (Props) => {
  const [progress, setProgress] = useState(0);

  const {data, isLoading: isMeLoading} = useMe();
  const today = new Date();
  const {interventions, isError, isLoading} = useDailyIntervention({
    size: 5,
    filter: {
      startDate: simpleDate(today),
      status: [
        interventionStatus.NEW,
        interventionStatus.PROCESSING,
        interventionStatus.REPORTED,
      ],
    },
    order: [["startDate", "ASC"]],
  });
  useEffect(() => {
    if (!isMeLoading && data) {
      setProgress(getProgressPercentage(data));
    }
  }, [data, isMeLoading]);
  const getProgressPercentage = (data) => {
    if (!data) return 0;

    const checks = [
      !!data?.phone?.length,
      // !!data?.Technician?.taxRegistrationNumber,
      // !!data?.Technician?.companyName?.length,
      !!data?.Technician?.bio?.length,
      !!data?.address?.length,
      !!data?.Technician?.FileUploads?.length,
      !!data?.Technician?.InterventionAreas?.length,
      !!data?.Technician?.SubCategories?.length,
      !!data?.Technician?.BankAccounts?.length,
    ];

    const completed = checks.filter(Boolean).length; // Count all truthy values
    const total = checks.length;

    return (completed / total) * 100;
  };

  if (isMeLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="w-full  lg:grid lg:grid-cols-4 gap-6 ">
        <div className="w-full h-fit bg-white rounded-2xl hidden lg:block sticky top-[90px]  ">
          <div
            className="w-full h-[84px] bg-cover bg-center rounded-t-xl relative "
            style={{backgroundImage: `url('${BgPattern}')`}}
          >
            <div className="absolute -bottom-12 rounded-md left-[50%] -translate-x-[50%]">
              <div className="relative">
                {!!data?.avgRating && (
                  <Link
                    to={"/mon-profil/#avis"}
                    className="bg-[#FFC107] w-1/2 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[12px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
                  >
                    {Number(data?.avgRating).toFixed(2)}
                    <StarIcon className="fill-white stroke-none w-3 h-3" />
                  </Link>
                )}
                {!!data?.Technician?.taxRegistrationNumber && (
                  <div className="absolute w-6 h-6 bg-white flex justify-center items-center top-1 right-1 text-[#1A64B9] rounded-full">
                    <img
                      className="w-4"
                      src={Crown}
                      alt=""
                      title="Professionnel"
                    />{" "}
                  </div>
                )}
                <Link to={"/mon-profil"}>
                  <ImageComponent
                    src={buildImageUrl(data?.imageUri)}
                    alt=""
                    className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                    fallback={
                      <img
                        src={NoProfile}
                        alt=""
                        className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                        width="130"
                      />
                    }
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-5">
            <Link
              to={"/mon-profil"}
              className="text-center text-[#19295C] font-semibold capitalize "
            >
              {`${data.lastName}  ${data.firstName}`}
            </Link>
            <div className="text-center text-primary font-normal text-sm">
              {data.selectedRole === userRoleList.TECHNICIAN
                ? "Prestataire"
                : "Client"}
            </div>
            <div className="text-xs font-medium text-center text-[#9B9B9B] px-[26px] mt-3 line-clamp-5">
              {data?.Technician?.bio ?? ""}
            </div>

            <Link
              to="/mon-profil"
              className="w-full px-3 py-4 flex justify-center items-center border-b border-solid border-[#D6E2EF] cursor-pointer "
            >
              {progress !== 100 && (
                <ProfileCompletion
                  progress={progress.toFixed(0)}
                  onCompleteProfile={() => {}}
                />
              )}
            </Link>

            <Link
              to={"/tableau-de-bord"}
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-2xl text-[#6B6B6B] border-b border-solid group hover:text-[#FF6600] border-[#D6E2EF] px-4 py-3 "
            >
              <i className="fi fi-rr-dashboard-panel flex justify-center items-center group-hover:text-[#FF6600]"></i>
              <span className="font-semibold text-[15px] text-[#9B9B9B] group-hover:text-[#FF6600] ">
                Tableau de bord
              </span>
            </Link>
            <Link
              to={"/mon-profil"}
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-2xl text-[#6B6B6B] group hover:text-[#FF6600] px-4 py-3 "
            >
              <i className="fi fi-rr-user flex justify-center items-center group-hover:text-[#FF6600]"></i>
              <span className="font-semibold text-[15px] text-[#9B9B9B] group-hover:text-[#FF6600]  ">
                Mon profil
              </span>
            </Link>
          </div>
        </div>
        <div className="w-full col-span-2 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-3">
          <Outlet />
        </div>

        <div className="w-full hidden  h-fit    pb-4  lg:flex flex-col gap-4 self-start  ">
          <Weather />
          <div className="w-full rounded-2xl  bg-white flex flex-col text-[#19295C] font-bold text-xl ">
            <div className="w-full flex items-start justify-between !py-3 !pl-3 !pr-1">
              <span className="font-semibold text-lg">
                Interventions à venir
              </span>
              <Link to={"/interventions"}>
                <img src={arrow} className="cursor-pointer" alt="" />
              </Link>
            </div>
            {isLoading && <Loader />}
            {isError && (
              <div className="p-4 text-red text-center">
                "Oups ! Un problème est survenu lors de la récupération des
                données. Veuillez vérifier votre connexion ou réessayer plus
                tard."
              </div>
            )}
            {interventions && !!interventions.length ? (
              interventions.map((intervention) => (
                <InterventionItem
                  key={intervention.id}
                  intervention={intervention}
                  className={"border-b border-solid border-[#D6E2EF] "}
                />
              ))
            ) : (
              <div className="text-center py-3 font-medium text-base text-[#7e7e7e]">
                Pas d'interventions.
              </div>
            )}
          </div>

          <PubList />
        </div>
      </div>
    </>
  );
};

export default TechContainer;
